import React from 'react';
import D2Agent from './Components/D2Agent';
import './App.css';

function App() {
  return (
    <div className="App" style={{ width: "100%", height: "100%" }}>
      <D2Agent />
    </div>
  );
}

export default App;
